import React from "react";
import { useEffect } from "react";
import Vault from "../images/LoginImage.png";
import "./login.css";
import LoginForm from "./LoginForm";
function LoginComponent() {
  useEffect(() => {
    // 👇 add class to body element
    document.body.classList.add("login-page");
  }, []);
  return (
    <div className="loginBox">
            <LoginForm />
    </div>
  );
}

export default LoginComponent;
